import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getSingleProduct } from "../../reducers/commonReducer";
import Header from '../../ComponentsWeb/Sub/Header';
import { orderCreate } from "../../reducers/orderDetailsReducer";
import {useRazorpay} from 'react-razorpay';




const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const PlansDetails = () => {
  const dispatch = useDispatch();
  const Razorpay = useRazorpay();
  const { getSingleProductData } = useSelector((state) => state.commonReducer);

  const query = useQuery();
  const planId = query.get("id");

  
  useEffect(() => {
    
    dispatch(getSingleProduct({ id: planId }));
  }, [dispatch, planId]);
  

  const handleOrderCreate = async () => {
    const res = await dispatch(orderCreate({ product: planId }));
  
    const orderDetail = res?.payload?.orderDetail;
    const user = res?.payload?.user;
    const key = res?.payload?.key;
    const localOrderId = res?.payload?.localOrderId;
    if (orderDetail && window.Razorpay) {
      
      const options = {
        key: key,
        amount: orderDetail.amount,
        currency: orderDetail.currency,
        name: 'TaxNwealth',
        description: 'Transaction',
        order_id: orderDetail.id,
        callback_url: 'http://localhost:3000/payment-success',
        prefill: {
          name: user?.firstName+" "+user?.lastName,
          email: user?.email, 
          contact: user?.phone,
        },
        theme: {
          color: '#F37254',
        },
        // handler: function (response) {
        //   console.log('Payment response:', response);
  
        //   fetch('/verify-payment', {
        //     method: 'POST',
        //     headers: {
        //       'Content-Type': 'application/json',
        //     },
        //     body: JSON.stringify({
        //       razorpay_order_id: response.razorpay_order_id,
        //       razorpay_payment_id: response.razorpay_payment_id,
        //       razorpay_signature: response.razorpay_signature,
        //     }),
        //   })
        //     .then((res) => res.json())
        //     .then((data) => {
        //       if (data.status === 'ok') {
        //         window.location.href = '/payment-success';
        //       } else {
        //         alert('Payment verification failed');
        //       }
        //     })
        //     .catch((error) => {
        //       console.error('Error:', error);
        //       alert('Error verifying payment');
        //     });
        // },
        handler: function (response) {
          console.log(response);
          
          const orderId = localOrderId;
          if (orderId) {
            window.location.href = `/response/${orderId}`;
          } else {
            alert("Order ID missing in payment response.");
          }
        },
        
      };
      
      if (typeof Razorpay === "undefined") {
        console.log("Razorpay SDK not loaded.");
      }
      

      const rzp = new window.Razorpay(options); 
      rzp.open();
    } else {
      alert('Unable to initiate payment. Razorpay SDK not loaded.');
    }
  };


  return (
    <>
      <Header />
      <div className="container-fluid py-5">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-6 col-md-8 mb-4">
            <div className="plan-card h-100 p-4 border shadow-sm rounded">
              <h2 className="fw-bold text-center mb-5">
                {getSingleProductData?.category?.shortName} Plan
              </h2>

              <div className="d-flex justify-content-between reverse-col">
                <div className="mb-2">
                  <div className="plan-title fw-semibold mb-2">
                    {getSingleProductData?.name}
                  </div>
                  <ul className="text-start mb-2">
                    {Array.isArray(getSingleProductData?.benefits) ? (
                      getSingleProductData.benefits.map((benefit, i) => (
                        <li key={i}>{benefit}</li>
                      ))
                    ) : (
                      <li>{getSingleProductData?.benefits}</li>
                    )}
                  </ul>
                </div>
                <div className="mb-2">
                  <div className="plan-title fw-semibold mb-2">
                    Why Choose Our Services?
                  </div>
                  <ul>
                    <li>Expert Assistance from CA Professionals</li>
                    <li>Affordable and Transparent Pricing</li>
                    <li>Quick Turnaround Time</li>
                    <li>All-In-One Tax Filing Solutions</li>
                  </ul>
                </div>
              </div>

              <div className="plan-title fw-semibold mb-2">Details</div>
              <p className="plan-desc text-start">
                {getSingleProductData?.description}
              </p>
              <hr />

              <h4>Pay Summary</h4>
              <div className="price-block text-end my-3">
                <div>
                  <del>₹{getSingleProductData?.mrp}</del>&nbsp;
                  <strong>₹{getSingleProductData?.sale}</strong>
                  {getSingleProductData?.timeperiod && (
                    <span className="text-muted" style={{ fontSize: "13px" }}>
                      {" "}
                      / {getSingleProductData.timeperiod.replace("_", " ")}
                    </span>
                  )}
                </div>
                {getSingleProductData?.mrp && getSingleProductData?.sale && (
                  <div className="text-success" style={{ fontSize: "13px" }}>
                    You save ₹{getSingleProductData.mrp - getSingleProductData.sale} (
                    {Math.round(
                      ((getSingleProductData.mrp - getSingleProductData.sale) /
                        getSingleProductData.mrp) *
                        100
                    )}
                    %)
                  </div>
                )}
                <div className="text-muted" style={{ fontSize: "13px" }}>
                  + Taxes (GST)
                </div>
              </div>

              <div className="order-summary mt-4 text-end">
                <strong>Total: ₹{getSingleProductData?.sale || 0}</strong>
              </div>

              <div className="payment-section mt-4">
                <button
                  className="btn btn-success w-100"
                  onClick={handleOrderCreate}
                >
                  Proceed to Payment
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-5 text-center">
          <h4>Need Help?</h4>
          <p>
            Call us at <strong>1800-123-456</strong> or email{" "}
            <strong>support@example.com</strong>
          </p>
        </div>
      </div>
    </>
  );
};

export default PlansDetails;



